import { createSlice } from "@reduxjs/toolkit";

const getInitialTab = () => {
  const savedTab = localStorage.getItem("selected_tab");
  if (savedTab) {
    return savedTab;
  }
  try {
    const userData = JSON.parse(localStorage.getItem("zubrus_user_data"))?.data?.userInfo;
    if (userData?.userRoles?.includes('zubrus_parent')) {
      return "child";
    }
    if (userData?.userRoles?.includes('zubrus_content_creator')) {
      return "workshops";
    }
  } catch (e) {
    console.error("Error parsing user data from localStorage", e);
  }
  return "Klasės"; // Default for teacher or other roles
};

const tabSlice = createSlice({
  name: "tabdata",
  initialState: {
    tab: getInitialTab(),
  },
  reducers: {
    setTabData: (state, action) => {
      state.tab = action.payload;
      localStorage.setItem("selected_tab", action.payload);
    },
    resetTab: (state, action) => {
      state.tab = action.payload;
      localStorage.removeItem("selected_tab");
    },
  },
});

export const { setTabData, resetTab } = tabSlice.actions;

export default tabSlice.reducer;
